export const clickIdTracker = {
  getGoogleClickId() {
    return localStorage.getItem('gclid');
  },

  getGdanClidValue() {
    return localStorage.getItem('gdan_clid');
  },

  getFacebookClickId() {
    return getCookie('_fbc');
  },

  getFacebookBrowserId() {
    return getCookie('_fbp');
  }
};

function getCookie(key) {
  const cookies = `; ${document.cookie}`;
  const parts = cookies.split(`; ${key}=`);

  if (parts.length === 2) return parts.pop().split(';').shift();

  return null;
}
